import { createContext } from "react";

const GameRoomContext = createContext();

export default GameRoomContext;
